import { pbx_operators_base_breadcrumbs } from './_module';

const index = pbx_operators_base_breadcrumbs
  .extend('pbx.contact.index')
  .add('pbx.breadcrumb.contact.index', { name: 'pbx.contact.index' });

const create = index
  .extend('pbx.contact.create')
  .add('pbx.breadcrumb.contact.create', { name: 'pbx.contact.create' });

const edit = index
  .extend('pbx.contact.edit')
  .add('pbx.breadcrumb.contact.edit', { name: 'pbx.contact.edit' });

export const pbx_contact_breadcrumbs = [index, create, edit];
